module.exports = __webpack_public_path__ + "assets/media/carousel_3.5f1b4745.svg";